import { Service } from '../types';

export const services: Service[] = [
  {
    title: 'Home Renovations',
    description: 'Transform your living space with our comprehensive renovation services. From kitchen and bathroom remodels to whole-house renovations, we bring your vision to life.',
    features: [
      'Kitchen and bathroom remodeling',
      'Basement finishing',
      'Room additions',
      'Interior updates',
      'Structural modifications'
    ],
    imageKey: 'renovations'
  },
  {
    title: 'New Construction',
    description: 'Build your dream home from the ground up with our expert construction services. We handle every aspect of new home construction with precision and care.',
    features: [
      'Custom home building',
      'Project management',
      'Site preparation',
      'Foundation work',
      'Complete construction services'
    ],
    imageKey: 'newConstruction'
  },
  {
    title: 'Custom Carpentry',
    description: 'Add beautiful, functional woodwork to your home with our custom carpentry services. From built-ins to custom furniture, we create pieces that last.',
    features: [
      'Built-in cabinets and shelving',
      'Custom furniture',
      'Trim and molding work',
      'Custom doors and windows',
      'Architectural woodwork'
    ],
    imageKey: 'carpentry'
  },
  {
    title: 'Kitchen Remodeling',
    description: 'Create your dream kitchen with our expert remodeling services. We combine functionality with stunning design to make your kitchen the heart of your home.',
    features: [
      'Custom cabinetry',
      'Countertop installation',
      'Appliance fitting',
      'Lighting design',
      'Storage solutions'
    ],
    imageKey: 'kitchenRemodeling'
  },
  {
    title: 'Bathroom Remodeling',
    description: 'Transform your bathroom into a luxurious retreat. From simple updates to complete renovations, we create beautiful and functional spaces.',
    features: [
      'Custom showers and tubs',
      'Tile installation',
      'Vanity and cabinet work',
      'Plumbing updates',
      'Lighting improvements'
    ],
    imageKey: 'bathroomRemodeling'
  },
  {
    title: 'Outdoor Living',
    description: 'Extend your living space outdoors with custom decks, patios, and outdoor kitchens. Create the perfect space for entertaining and relaxation.',
    features: [
      'Custom deck building',
      'Pergola construction',
      'Outdoor kitchen installation',
      'Patio design and construction',
      'Outdoor living spaces'
    ],
    imageKey: 'outdoorLiving'
  }
]; 